"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStatus = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@chakra-ui/react");
var ApplicationStatus = function (_a) {
    var isApplied = _a.isApplied, holdingStatus = _a.holdingStatus, children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null, isApplied ? (react_1.default.createElement(react_2.Box, { mt: "1rem", textAlign: "center" },
        react_1.default.createElement(react_2.Text, { fontSize: "1.6rem" }, "\u304A\u5BA2\u69D8\u306F\u3059\u3067\u306B\u3054\u5FDC\u52DF\u3044\u305F\u3060\u3044\u3066\u304A\u308A\u307E\u3059\u3002"),
        react_1.default.createElement(react_2.Box, { mt: "1rem" },
            react_1.default.createElement(react_2.Button, { as: "a", href: "/main", color: "white", bg: "#F9B812", size: "lg", height: "4rem", fontSize: "1.6rem", minW: "10rem", _hover: {
                    color: "white",
                    backgroundColor: "#D59D0F",
                    textDecoration: "none",
                }, _active: {
                    color: "white",
                    backgroundColor: "#BF8D0D",
                } }, "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u623B\u308B")))) : holdingStatus !== "active" ? (react_1.default.createElement(react_2.Box, { mt: "1rem", textAlign: "center" },
        react_1.default.createElement(react_2.Text, { fontSize: "1.6rem" },
            holdingStatus === "before" &&
                "プレゼントキャンペーンは開催前です。",
            holdingStatus === null &&
                "キャンペーンは開催しておりません。",
            holdingStatus === "after" &&
                "プレゼントキャンペーンは終了しました。"),
        react_1.default.createElement(react_2.Box, { mt: "1rem" },
            react_1.default.createElement(react_2.Button, { as: "a", href: "/main", color: "white", bg: "#F9B812", size: "lg", height: "4rem", fontSize: "1.6rem", minW: "10rem", _hover: {
                    color: "white",
                    backgroundColor: "#D59D0F",
                    textDecoration: "none",
                }, _active: {
                    color: "white",
                    backgroundColor: "#BF8D0D",
                } }, "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u623B\u308B")))) : (react_1.default.createElement(react_1.default.Fragment, null, children))));
};
exports.ApplicationStatus = ApplicationStatus;
